<template>
<div class="finder-storeinfo" :class="{ 's_active' : this.isActive }">
  <div class="finder-content">
    <h1 class="splithero-title">{{ store.title }}</h1>
    <h4 class="l_light l_min-footspace">Call {{ store.phone }}</h4>
    <p><span v-if="store.address1">{{ store.address1 }}, </span><nobr>{{ store.suburb }} {{ store.stateAbbrev }} {{ store.postcode }}</nobr><br />
    <a :href="`mailto:${store.email}`" class="l_bp-mama">{{ store.email }}</a><a :href="`mailto:${store.email}`" class="l_bpm-mama">Email us</a></p>
    <h5 class="l_min-footspace" v-html="openNow"></h5>
    <p v-html="openHours"></p>

    <a :href=store.url class="btn">Visit store page</a>

    <button @click="closeBox" class="finder-return">&laquo; Return to all results</button>

    <!-- <div class="filter l_small" data-type="input" data-id="keywords">
      <input type="text" name="keywords" placeholder="Enter suburb or postcode" class="filter-input">
      <svg class="icon filter-icon"><use xlink:href="#search"></use></svg>
    </div> -->

  </div>
</div>
</template>

<script>
import getDistance from 'geolib/es/getDistance';
import EventBus from '../utils/event-bus';
import * as openHours from '../utils/open-hours';
export default {
  name: "StoreInfo",
  data() {
    return {

      store: false,
      isActive: false

    };
  },
  props: {
    searchId: String
  },
  computed: {

    openNow() {
      return openHours.displaySimple(this.store);
    },

    openHours() {
      return openHours.outlook(this.store);
    },

  },
  methods: {

    closeBox() {

      this.isActive = false;
      EventBus.$emit('STORE_HIDE', this.searchId);

    },

  },
  mounted() {

    EventBus.$on('STORE_DISPLAY', (searchId, store) => {
      this.store = store;
      this.isActive = true;
    });

  },
};
</script>

<style scoped>
</style>